import { utils } from "@project-serum/anchor";
import { PublicKey } from "@solana/web3.js";

import { QUARRY_ADDRESSES } from "../../constants";

export const findPositionWrapperAddress = async (
  base: PublicKey,
  programID: PublicKey = QUARRY_ADDRESSES.PositionWrapper
): Promise<[PublicKey, number]> => {
  return await PublicKey.findProgramAddress(
    [Buffer.from(utils.bytes.utf8.encode("PositionWrapper")), base.toBytes()],
    programID
  );
};

export const findWrapMintAddress = async (
  wrapper: PublicKey,
  programID: PublicKey = QUARRY_ADDRESSES.PositionWrapper
): Promise<[PublicKey, number]> => {
  return await PublicKey.findProgramAddress(
    [Buffer.from(utils.bytes.utf8.encode("WrapMint")), wrapper.toBytes()],
    programID
  );
};

export const findPositionAddress = async (
  nftMint: PublicKey,
  programID: PublicKey = QUARRY_ADDRESSES.PositionWrapper
): Promise<[PublicKey, number]> => {
  return await PublicKey.findProgramAddress(
    [Buffer.from(utils.bytes.utf8.encode("Position")), nftMint.toBytes()],
    programID
  );
};
